<div class="drawer-header border-bottom">
  <span class="title">histórico de documentos</span>
  <p-button (onClick)="closeModal()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" />
</div>
<div class="content-drawer">
  <br>
  <div class="basic-info">
    <div class="avatar">
      <p-avatar
        *ngIf="!imageError && imagePreview; else defaultAvatar"
        [image]="$any(imagePreview)"
        shape="circle"
        size="xlarge"
        (onImageError)="imageError = true"
      />
      <ng-template #defaultAvatar>
        <p-avatar
          [label]="getInitials(estudanteSelected?.nome)"
          [icon]="!estudanteSelected?.nome ? 'pi pi-user' : undefined"
          shape="circle"
          size="xlarge"
        />
      </ng-template>
    </div>
    <div class="details">
      <h3 class="name">{{ estudanteSelected?.nome || 'sem informações disponíveis de momento' }}</h3>
      <div class="info">
        <span> <strong> Nº BI: {{ estudanteSelected?.numeroBI || 'sem informações disponíveis de momento' }}
          </strong></span>
        <span>&nbsp; • &nbsp;</span>
        <span> <p-tag *ngIf="estudanteSelected?.isActive" severity="success" value="Activo" />
          <p-tag *ngIf="!estudanteSelected?.isActive" severity="danger" value="Inactivo" /> </span>
      </div>
    </div>
  </div>
  <br>

  <div class="drawer-head flex w-full mb-3">


    <div class="actions d-flex justify-content-between gap-2 w-full">
      <p-button label="Filtros" icon="pi pi-filter" [text]="true" (onClick)="showFilter = true" />
      <p-button label="Carregar documento" icon="pi pi-upload" (onClick)="openUpload()" />
    </div>
  </div>


  <p-dialog [(visible)]="showFilter" [modal]="true" [showHeader]="false" [style]="{ width: '44rem' }" appendTo="body">
    <div class="custom-modal-layout">
      <div class="modal-header">
        <div class="icon">
          <i class="pi pi-filter"></i>
        </div>
        <span class="title">Filtros</span>
        <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="showFilter = false" />
      </div>

      <form [formGroup]="form" (ngSubmit)="applyFilters()">
        <div class="p-fluid grid">
          <div class="field col-12">
            <label>Tipo de Documento</label>
            <p-select class="w-full" [options]="tipoDocOptions" optionLabel="designacao" optionValue="id"
              formControlName="TipoDocumento" [filter]="true" appendTo="body">
            </p-select>
          </div>

          <div class="field col-12">
            <label>Estado</label>
            <p-select class="w-full" [options]="estadoDocOptions" optionLabel="designacao" optionValue="id"
              formControlName="EstadoDocumento" [showClear]="true" appendTo="body">
            </p-select>
          </div>

          <div class="field col-12">
            <label>Activo</label>
            <p-select class="w-full" [options]="ativoOptions" optionLabel="designacao" optionValue="id"
              formControlName="Ativo" [showClear]="true" appendTo="body">
            </p-select>
          </div>

          <!-- <div class="field col-12">
          <label>Utilizador ID</label>
          <input pInputText class="w-full" placeholder="Ex.: 123 ou e-mail" formControlName="UtilizadorID" />
        </div> -->
        </div>

        <div class="modal-footer">
          <p-button pButton type="button" label="Cancelar" class="p-button-outlined"
            (click)="showFilter = false"></p-button>
          <p-button pButton type="button" label="Limpar" class="p-button-secondary" (click)="clearFilters()"></p-button>
          <p-button pButton type="submit" label="Aplicar" class="p-button-primary"></p-button>
        </div>
      </form>
    </div>
  </p-dialog>


  <!-- <div class="table-wrap" *ngIf="rows?.length; else empty">
  <p-table [value]="rows" [loading]="loading" [rows]="form.value.PageSize" [paginator]="true"
    [totalRecords]="pagination.totalRecords" (onPage)="onPageChange($event)">
    <ng-template pTemplate="header">
      <tr>
        <th>Tipo</th>
        <th>Estado</th>
        <th>Emissão</th>
        <th>Actualização</th>
        <th>Utilizador</th>
        <th style="width:1%"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-r>
      <tr>
        <td>{{ r.tipoDocumentoDescricao }}</td>
        <td><p-tag [value]="r.estadoDocumentoDescricao"></p-tag></td>
        <td>{{ r.dataEmissaoFormatada || (r.dataEmissao | date:'dd/MM/yyyy') }}</td>
        <td>{{ r.dataModificacaoFormatada || (r.dataModificacao | date:'dd/MM/yyyy') }}</td>
        <td>{{ r.utilizadorID || '—' }}</td>
        <td class="text-right">
          <p-button icon="pi pi-download" class="p-button-text" (onClick)="download(r)" pTooltip="Baixar documento"
            tooltipPosition="top" />
        </td>
      </tr>
    </ng-template>
  </p-table>
</div> -->
  <div *ngIf="pagination?.data?.length; else empty">
    <app-table [pagination]="pagination" [columns]="columns" [actions]="actions" (pageChange)="onPageChange($event)"
      (actionSelected)="onActionSelected($event)">
    </app-table>
  </div>

  <ng-template #empty>
    <app-data-void titulo="Sem documentos" descricao="Nenhum histórico para os filtros aplicados.">
    </app-data-void>
  </ng-template>

  <p-toast /> <p-confirmDialog></p-confirmDialog>